import React from 'react';
import { Skeleton } from 'antd';

interface ChartSkeletonProps {
  height?: number;
}

/** Skeleton for chart area to prevent layout shift */
export const ChartSkeleton: React.FC<ChartSkeletonProps> = ({
  height = 350,
}) => (
  <div
    className="chart-skeleton"
    style={{ height, position: 'relative', overflow: 'hidden' }}
  >
    <div className="chart-skeleton-shimmer" />
    <div className="chart-skeleton-content">
      <Skeleton.Input
        active
        size="small"
        style={{ width: 60, marginBottom: 8 }}
      />
      <Skeleton.Input active size="small" style={{ width: 80 }} />
      <div style={{ marginTop: 24, display: 'flex', gap: 16 }}>
        {[1, 2, 3, 4, 5, 6].map(i => (
          <Skeleton.Avatar
            key={i}
            active
            shape="square"
            style={{ width: '100%', maxWidth: 40, height: 120 }}
          />
        ))}
      </div>
    </div>
  </div>
);
